import { Suspense, lazy } from 'react';
import type { Components } from 'react-markdown';

const MarkdownContentInner = lazy(() => import('./MarkdownContentInner'));

export type MarkdownContentProps = {
  children: string;
  className?: string;
  components?: Components;
};

export const MarkdownContent = ({
  children,
  className,
  components,
}: MarkdownContentProps) => (
  <Suspense fallback={null}>
    <MarkdownContentInner className={className} components={components}>
      {children}
    </MarkdownContentInner>
  </Suspense>
);
